// Minimaler Modal-Dialog im App-Look.
// Klick auf Overlay oder ESC schliesst — destruktive Aktionen
// kapseln das Eltern-Component selbst (z.B. mit window.confirm).

import { useEffect } from "react";
import type { ReactNode } from "react";

import "./Modal.css";

interface ModalProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

export function Modal({ title, onClose, children, footer }: ModalProps) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div
      className="bmd-modal-overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="bmd-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bmd-modal-title"
      >
        <header className="bmd-modal-header">
          <h2 id="bmd-modal-title" className="bmd-modal-title">
            {title}
          </h2>
          <button
            type="button"
            className="bmd-modal-close"
            onClick={onClose}
            aria-label="Schließen"
          >
            ×
          </button>
        </header>
        <div className="bmd-modal-body">{children}</div>
        {footer && <footer className="bmd-modal-footer">{footer}</footer>}
      </div>
    </div>
  );
}
